// extracted by mini-css-extract-plugin
export default {"home":"c-c_cQ","home__content":"c-c_cR"};